import { Star, ExternalLink, PenLine, Facebook, ShieldCheck } from "lucide-react";
import { BUSINESS } from "../../data/business";
import { CLEANING_REVIEWS } from "../../data/cleaningContent";

// Only verified reviews supplied by the owner render as cards. No placeholders.
function ReviewCard({ r, i }) {
  return (
    <article className="ss-card p-6" data-testid={`review-${i}`}>
      {r.rating && (
        <div className="flex items-center gap-1 text-amber-500 mb-3" role="img" aria-label={`${r.rating} out of 5 stars`}>
          {[...Array(r.rating)].map((_, k) => <Star key={k} size={14} className="fill-amber-500 text-amber-500" aria-hidden="true" />)}
        </div>
      )}
      <p className="text-slate-700 text-sm leading-relaxed">“{r.text}”</p>
      <div className="mt-5 flex items-center justify-between gap-3">
        <div>
          <div className="text-sm font-semibold text-slate-900">{r.name}</div>
          {r.city && <div className="text-xs text-slate-500">{r.city}</div>}
        </div>
        <a href={r.sourceUrl} target="_blank" rel="noreferrer" className="text-xs text-slate-500 underline hover:text-[#1E3A8A]">{r.source}</a>
      </div>
    </article>
  );
}

function VerifiedPanel() {
  return (
    <div className="ss-card p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-6" data-testid="reviews-verified-panel">
      <span className="h-14 w-14 rounded-2xl bg-emerald-100 text-emerald-700 inline-flex items-center justify-center shrink-0"><ShieldCheck size={26} /></span>
      <div className="flex-1">
        <h3 className="font-display text-xl font-semibold text-slate-900">Read our reviews where they were written</h3>
        <p className="text-slate-600 mt-1 text-sm md:text-base">See what real customers say on our verified Google and Facebook business profiles.</p>
      </div>
      <a href={BUSINESS.facebook} target="_blank" rel="noreferrer" className="btn-outline" data-testid="reviews-facebook-btn">
        <Facebook size={16} /> Facebook Reviews
      </a>
    </div>
  );
}

export default function Reviews() {
  return (
    <section id="reviews" className="section bg-[#F8FAFC]">
      <div className="container-ss">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div className="max-w-2xl">
            <span className="pill mb-3">Reviews</span>
            <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
              What our <span className="text-[#1E3A8A]">neighbors</span> are saying
            </h2>
            <p className="text-slate-600 mt-3">Real reviews from real customers across Northwest Indiana.</p>
          </div>
          <div className="flex flex-wrap gap-3">
            <a href={BUSINESS.googleBusiness} target="_blank" rel="noreferrer" className="btn-primary" data-testid="reviews-read-btn">
              <ExternalLink size={16} /> Read Our Google Reviews
            </a>
            <a href={BUSINESS.googleBusiness} target="_blank" rel="noreferrer" className="btn-green" data-testid="reviews-leave-btn">
              <PenLine size={16} /> Leave Us a Google Review
            </a>
          </div>
        </div>

        {CLEANING_REVIEWS.length ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {CLEANING_REVIEWS.map((r, i) => <ReviewCard key={`${r.name}-${i}`} r={r} i={i} />)}
          </div>
        ) : (
          <VerifiedPanel />
        )}
      </div>
    </section>
  );
}
